import React from 'react';
import { Link } from 'react-router-dom';
import T from './T';
import { useSiteContent } from '../hooks/useSiteContent';
import { useLocalizedText } from '../hooks/useLocalizedText';

const Footer: React.FC = () => {
  const { content } = useSiteContent();
  const firmName = useLocalizedText(content.contact.firmName);
  const footerTagline = useLocalizedText(content.contact.footerTagline);
  const torontoTitle = useLocalizedText(content.contact.torontoOffice.title);
  const beijingTitle = useLocalizedText(content.contact.beijingOffice.title);

  return (
    <footer style={{
      backgroundColor: '#FFFFFF', // Changed to white
      color: '#9E9E9E', // Updated font color
      padding: '3rem 2rem',
      borderTop: '1px solid rgba(0, 212, 255, 0.3)',
      marginTop: 'auto',
      transition: 'var(--transition)'
    }}>
      <div className="container" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '2rem'
      }}>
        <div>
          <h3 style={{ 
            color: 'var(--primary-color)', 
            marginBottom: '1rem',
            textShadow: '0 0 10px rgba(0, 212, 255, 0.5)'
          }}>{firmName}</h3>
          <p>{footerTagline}</p>
          <Link to="/articles" style={{ color: 'var(--secondary-color)', display: 'block', marginTop: '1rem', fontWeight: 'bold' }}>
            <T>Legal Articles & Insights</T>
          </Link>
        </div>
        <div>
          <h4 style={{ marginBottom: '1rem', color: '#012128' }}>{torontoTitle}</h4>
          {content.contact.torontoOffice.addressLines.map((line) => <p key={line}>{line}</p>)}
          <p>Phone: {content.contact.torontoOffice.phone}</p>
          <p>Fax: {content.contact.torontoOffice.fax}</p>
          <p>WeChat: 905 955 8818</p>
        </div>
        <div>
          <h4 style={{ marginBottom: '1rem', color: '#012128' }}>{beijingTitle}</h4>
          {content.contact.beijingOffice.addressLines.map((line) => <p key={line}>{line}</p>)}
          <p>Phone: {content.contact.beijingOffice.phone}</p>
        </div>
        <div>
          <h4 style={{ marginBottom: '1rem', color: '#012128' }}><T>Contact Us</T></h4>
          <p>Email: {content.contact.torontoOffice.email}</p>
          <Link to="/contact" style={{ color: 'var(--secondary-color)', display: 'block', marginTop: '0.75rem', fontWeight: 'bold' }}><T>Contact</T></Link>
          <p style={{ marginTop: '1rem' }}>© 2026 Y. Liu Law Firm. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
